import axios from 'axios';

import config from '@/config/config';
import { headers } from './auth.headers';
import { formatQueryString } from '@/helpers/query-string';
import { IInsideSales } from '@/domain/inside-sales.model';
import { IPaginateVueTable } from '@/interfaces/IPaginateVueTable';

const url_api_base = config.url_api_base;

export const insert = (data: IInsideSales): Promise<IInsideSales> => {
  return axios.post(`${url_api_base}/inside-sales`, data, headers());
};

export const update = (data: IInsideSales): Promise<IInsideSales> => {
  return axios.patch(`${url_api_base}/inside-sales/${data.id}`, data, headers());
};

export const get = (id: string): Promise<IInsideSales> => {
  const url = `${url_api_base}/inside-sales/${id}`;

  return axios.get(url, headers()).then((res) => res?.data);
};

export const list = (
  offset?: number,
  limit?: number,
  order?: string,
  sort?: string,
  filter?: string,
): Promise<IPaginateVueTable<IInsideSales>> => {
  const query = formatQueryString(offset, limit, order, sort, filter);
  const url = `${url_api_base}/inside-sales${query}`;

  return axios.get(url, headers()).then((res) => res?.data);
};
